/**
 * クライアント側の検証（サーバでも同じ検証をする。ここは早期フィードバック用）
 */
import { SimulationShift } from './types';
import { hmToMinutes } from './time';

export const MAX_SHIFTS_PER_CELL = 3;

export type ValidationResult = { ok: true } | { ok: false; message: string };

const spanOf = (s: SimulationShift): [number, number] | null => {
  if (s.attendType !== 0 || !s.start || !s.end) {
    return null;
  }
  const a = hmToMinutes(s.start);
  let b = hmToMinutes(s.end, s.isEndNextDay);
  if (b <= a) {
    b += 1440;
  }
  return [a, b];
};

/** セルに追加できるか（件数・公休との同居・重なり） */
export const validateCell = (existing: Array<SimulationShift>, candidate: SimulationShift): ValidationResult => {
  const live = existing.filter((s) => !s.deleted);
  if (live.length >= MAX_SHIFTS_PER_CELL) {
    return { ok: false, message: `1セルに登録できるシフトは${MAX_SHIFTS_PER_CELL}件までです。` };
  }
  if (candidate.attendType !== 0 && live.length > 0) {
    return { ok: false, message: '公休はシフトと同じ日に登録できません。' };
  }
  if (candidate.attendType === 0 && live.some((s) => s.attendType !== 0)) {
    return { ok: false, message: '公休が登録されている日にはシフトを登録できません。' };
  }
  const c = spanOf(candidate);
  if (c) {
    const overlap = live.some((s) => {
      const t = spanOf(s);
      return t !== null && c[0] < t[1] && t[0] < c[1];
    });
    if (overlap) {
      return { ok: false, message: '同じ時間帯にシフトが登録されています。' };
    }
  }
  return { ok: true };
};

/** 開始・終了の整合 */
export const validateTimes = (start: string | null, end: string | null): ValidationResult => {
  if (!start) {
    return { ok: false, message: 'シフトの開始時間が設定されていません。' };
  }
  if (!end) {
    return { ok: false, message: 'シフトの終了時間が設定されていません。' };
  }
  if (start === end) {
    return { ok: false, message: '開始時間と終了時間が同じです。' };
  }
  return { ok: true };
};

/**
 * 日ビューの移動・伸縮を軸内にクランプする（分）
 * @param axisStart 軸の開始（分。例 6:00 = 360）
 * @param axisMinutes 軸の長さ（分）
 */
export const clampSpan = (
  start: number, end: number, axisStart: number, axisMinutes: number, minSpan: number = 15,
): [number, number] => {
  const axisEnd = axisStart + axisMinutes;
  let s = Math.max(axisStart, start);
  let e = Math.min(axisEnd, end);
  if (e - s < minSpan) {
    if (s + minSpan <= axisEnd) {
      e = s + minSpan;
    } else {
      s = e - minSpan;
    }
  }
  return [s, e];
};
